import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { FiTrash2, FiAlertTriangle } from "react-icons/fi";
import { showToast } from "../../../components/common/notification/Notification";

const PromotionDeleteModal = ({
  show,
  onHide,
  promotion,
  promotionService,
  onPromotionDeleted,
}) => {
  const [deleting, setDeleting] = useState(false);

  if (!promotion) return null;

  const handleDelete = async () => {
    try {
      setDeleting(true);
      const res = await promotionService.remove(promotion.id);
      if (res?.statusType === "SUCCESS" || res?.status === 200 || !res?.isError) {
        showToast("Promotion deleted successfully", { type: "success" });
        if (onPromotionDeleted) onPromotionDeleted(promotion.id);
        onHide();
      } else {
        showToast(res?.message || res?.text || "Failed to delete promotion", {
          type: "error",
        });
      }
    } catch (err) {
      console.error("Failed to delete promotion:", err);
      showToast("Error deleting promotion", { type: "error" });
    } finally {
      setDeleting(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered size="sm">
      <Modal.Header closeButton style={{ borderBottom: "1px solid #f1f5f9" }}>
        <Modal.Title
          style={{
            fontSize: "16px",
            fontWeight: "700",
            display: "flex",
            alignItems: "center",
            gap: "8px",
            color: "#dc2626",
          }}
        >
          <FiAlertTriangle /> Delete Promotion
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ fontSize: "14px", color: "#475569", padding: "20px" }}>
        Are you sure you want to delete{" "}
        <strong>"{promotion.project_name || "this promotion"}"</strong>? This will remove
        all associated media, comments, and attachments.
      </Modal.Body>
      <Modal.Footer style={{ borderTop: "1px solid #f1f5f9" }}>
        <button
          type="button"
          className="btn btn-sm btn-outline-secondary"
          onClick={onHide}
          disabled={deleting}
        >
          Cancel
        </button>
        <button
          type="button"
          className="btn btn-sm btn-danger d-inline-flex align-items-center gap-2"
          onClick={handleDelete}
          disabled={deleting}
        >
          {deleting ? (
            <>
              <span className="spinner-border spinner-border-sm" /> Deleting...
            </>
          ) : (
            <>
              <FiTrash2 /> Delete
            </>
          )}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default PromotionDeleteModal;
